module.exports = __webpack_public_path__ + "static/presenter-a14bc499b769c4db7017b49fb95a10bc.gif";